<section class="steps">
  <section class="container">
    <div class="steps-title pt-3">
      Portal de <span class="text--red text--uppercase"><strong>pagos</strong> y recargas</span>
    </div>
    <div class="steps-icons pt-1 m-auto">
      <img class="" src="../../../../assets/images/icono-01-on-2.png" alt="">
      <img class="" [src]="imgPaymentMethod" alt="">
      <img class="" [src]="imgSummaryPayment" alt="">
      <img class="" [src]="imgPaymentConfirm" alt="">
    </div>
    <div class="steps-message text--blue pb-3 text-center">{{ txtMessage }}</div>
    <div class="espacio_flecha"><img class="" [src]="flag" alt=""></div>
  </section>
</section>
